import { getLocalizedOrDefault } from "../../../helpers/Functions";

const DisclaimerConfig = {
  collection: "disclaimers",
  fields: [
    "id",
    "name",
    "always_show_on",
    "paragraph",
    "symbol",
    "tag",
    "locale.body",
    "locale.languages_code.code",
    //scanners
    "locale.language",
    //bij energy
    "modified_on",
    "created_on"
  ],

  adapter: class Disclaimer {
    constructor(disclaimer) {
      this.id = disclaimer.id;
      this.name = disclaimer.name;
      this.always_show_on = disclaimer.always_show_on || [];
      this.paragraph = disclaimer.paragraph || 1;
      this.symbol = disclaimer.symbol;
      this.tag = disclaimer.tag;

      let locale = disclaimer.locale?.[0];
      this.locale = disclaimer.locale;
      this.body = locale?.body || "";
      this.date_updated = disclaimer.modified_on || disclaimer.created_on;
    }

    map(collections, maps) {
      // Include mapping of tag to disclaimer in disclaimers map
      if (this.tag) maps.disclaimers[this.tag] = this;

      this.locale = this.locale.map(
        ({ languages_code, language, ...other_props }) => ({
          ...other_props,
          language:
            maps.languages?.[languages_code?.code] || maps.locales?.[language]
        })
      );

      const { global_settings } = collections;
      const { default_locale } = global_settings;

      // e.g. field_name: header
      //      selected_locale: 'es-CL'
      this.getLocalized = (field_name, selected_locale) => {
        return getLocalizedOrDefault(
          this,
          field_name,
          { locale: selected_locale },
          { locale: default_locale }
        );
      };
    }
  }
};

export default DisclaimerConfig;
